import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Confirm, Breadcrumb } from 'semantic-ui-react'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { MainBodyContent } from 'components'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { appLoading } from 'ducks/app'
import { getSupplierFormData, clearVMFormData, updateVM, deleteVM, getWorkflow, checkTaxIdAvailable } from 'ducks/vendorMaintenance'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { checkAttachmentRequire } from '../AttributeData'
import { supplierPath } from 'routes'
import { 
  AccountingForm, 
  ApproveForm, 
  AttachmentForm, 
  CertificateAttachmentForm, 
  CommentHistory, 
  GeneralForm, 
  PurchasingForm, 
  RequestForm 
} from '../Form'
import { 
  showModal,
} from 'ducks/app'
import { VendorMaintenanceContainer, VendorMaintenanceBody } from '../Form/styled'

import r from 'reactotron-react-js'

const VendorMaintenanceEdit = (props) => {
  const { valueForm, formData, workflow } = props
  const [submit, setSubmit] = useState(false)
  const [mainFormClickSave, setMainFormClickSave] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')

  useEffect(() => {
    props.getSupplierFormData(props.match.params.id, props.history)

    return () => {
      props.clearVMFormData()
    }
  }, [])

  useEffect(() => {
    if(valueForm&&valueForm.accountGroup){
      if (['ZDOV', 'ZRPT', 'ZOTV'].includes(valueForm.accountGroup)) {
        props.change('grBasedInvoiceVerification', true)
      } else {
        props.change('grBasedInvoiceVerification', false)
      }
    }
  }, [valueForm&&valueForm.accountGroup])

  useEffect(() => {
    // if (formData.id) {
    //   if (formData.status !== 0 && formData.status !== 5) {
    //     props.history.push(vmDetailPath(formData.id))
    //   }
    // }

    if (formData.status) {
      props.getWorkflow(props.match.params.id)
    }
  }, [formData])

  const onSubmitEditForm = (values) => {
    const { updateVM, history, appLoading, attachmentGroups } = props

    if (mainFormClickSave) {
      if (submit) {
        let errors = {}
        if (values.purpose === 'create' || values.purpose === 'change') {
          const documentTypes = attachmentGroups.data.find(a => a.bpGroup === values.accountGroup) || { attachments: [] }
          if (['ZDOV', 'ZFOV', 'ZRPT', 'ZOTV'].includes(values.accountGroup)) {
            if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
              // if (values.notRegisterRemark === undefined || values.notRegisterRemark === null ||values.notRegisterRemark === '') {
              //   errors.notRegisterRemark = 'Required!'
              // }
            }
          }

          if (values.paymentTypeTransfer) {
            if ((values.vendorBanks || []).length === 0) {
              errors.paymentType = ' Minimum 1 row of bank account required!'
            }
          }

          documentTypes.attachments.forEach(d => {
            if (checkAttachmentRequire(d, values)) {
              if (((values[d.code] || []).length === 0) && ((values[`attachment${d.code.replace('VMA', '')}`] || []).length === 0)) {
                errors[d.code] = 'Require!'
              }
            }
          })

          if (values.accountGroup === 'ZRPT' && values.purpose === 'create') {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
      
          if (values.accountGroup === 'ZRPT' && values.purpose === 'change' && values.accountingViewLoaded === true) {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
        }
        if (Object.keys(errors).length) {
          let attachments = attachmentGroups.data.find(x=>x.bpGroup==valueForm.accountGroup).attachments
          let attachmentError = []
          Object.keys(errors).forEach(x=>{
            let f = attachments.find(s=>s.code.toLocaleLowerCase()==x.toLocaleLowerCase())
            if(f){
              attachmentError.push({fieldName:f.name})
            }
          })
          if(attachmentError.length){
            props.showModal(
              true, 
              'Please attach document!',
              <React.Fragment><ul>{attachmentError.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
            )
          }

          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          const { purpose, vendorCode, vendorType, taxId } = values
          if (purpose === 'create' || purpose === 'change') {
            props.checkTaxIdAvailable(
              { vendorCode, vendorType, taxId }, 
              () => { updateVM(values, submit, history, appLoading, undefined, true) }, 
              (message) => {
                setShowConfirmModal(true)
                setConfirmMessage(message)
              }
            )
          } else {
            updateVM(values, submit, history, appLoading, undefined, true)
          }
        }
      }
      setMainFormClickSave(false)
    }
  }

  const editableForm = () => {
    if (formData.status !== 0) {
      return (formData.sn !== undefined && formData.sn !== null && formData.sn !== '')
    } else {
      return true
    }
  }

  return (
    <MainBodyContent 
    headerTitle='Information - Convert'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'supplier', content: 'Suppliers', link: true, onClick: () => props.history.push(supplierPath) },
              { key: 'supplierConvert', content: 'Convert', active: true }
            ]
          }
        />
      }
    >
      <VendorMaintenanceContainer>
        {/* {
          formData.status ? 
            <DocumentStep documentDetail={formData} approvers={workflow.data} /> : null
        } */}
        <VendorMaintenanceBody>
          <form onSubmit={props.handleSubmit((values) => onSubmitEditForm(values))}>
            <RequestForm change={props.change} valueForm={valueForm}/>
            <GeneralForm change={props.change} valueForm={valueForm} />
            {
              valueForm.purpose === 'block' ? null : 
                <PurchasingForm change={props.change} valueForm={valueForm}/>
            }
            {
              valueForm.accountGroup === 'ZRPT' && (valueForm.purpose === 'create' || valueForm.purpose === 'change') ? 
                <AccountingForm change={props.change} valueForm={valueForm}/> : null
            }
            {
              valueForm.purpose === 'block' ? null : 
                <CertificateAttachmentForm change={props.change} valueForm={valueForm}/>
            }
            {
              valueForm.purpose === 'block' ? null : 
                <AttachmentForm change={props.change} valueForm={valueForm}/>
            }
            {
              formData && formData.comments && formData.comments.length ? <CommentHistory /> : null
            }
            <div className='btnContainer'>
              <div className='right'>
                <Button
                  type='submit'
                  content='Convert to vendor master'
                  color='blue'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setMainFormClickSave(true)
                    setSubmit(true)
                  }}
                />
              </div>
            </div>
          </form>
        </VendorMaintenanceBody>
      </VendorMaintenanceContainer>
      <Confirm
        open={showDeleteConfirm}
        cancelButton='Cancel'
        confirmButton='Delete'
        header='Vendor Maintenance'
        content='Do you want to delete document?'
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={() => {
          props.deleteVM(valueForm.id, props.history, () => setShowDeleteConfirm(false))
        }}
      />
      <Confirm 
        open={showConfirmModal}
        header='Warning!'
        content={
          <div style={{ padding: '1.25rem' }}>
            <p>{confirmMessage}</p>
            {
              valueForm.purpose === 'create' ?
                <p>Are you sure to create new Business Partner Code?</p> :
              valueForm.purpose === 'change' ?
                <p>Are you sure to change Business Partner Data?</p> : null
            }
          </div>
        }
        confirmButton='Yes'
        cancelButton='No'
        onConfirm={() => {
          setShowConfirmModal(false)
          props.updateVM(valueForm, submit, props.history, props.appLoading)
        }}
        onCancel={() => setShowConfirmModal(false)}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  // const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  const vf = getFormValues('formSupplierConvert')(state) || {}
  const fd = state.vendorMaintenance.formData.data

  const getValue = (key) => {
    return vf[key] !== undefined ? vf[key] : fd[key]
  }

  var initialValues = {
    id: fd.id,
    notRegisterRemark: '',
    title: getValue('title'),
    mobile: getValue('mobile'),
    telephone: getValue('telephone'),
    extension: getValue('extension'),
    website: getValue('website'),
    totalValueOfCurrentProject: getValue('totalValueOfCurrentProject'),
    totalValueOfCurrentProjectCurrency: getValue('totalValueOfCurrentProjectCurrency'),
    isFromVendor: getValue('isFromVendor'),
    listDealer: getValue('listDealer'),
    typeOfBusiness: getValue('typeOfBusiness'),
    typeOfBusinessOther: getValue('typeOfBusinessOther'),
    typeOfVendor: getValue('typeOfVendor'),
    requesterUser: localStorage.getItem('username'),
    requesterName: getValue('requesterName'),
    documentDate: getValue('documentDate'),
    documentNumber: getValue('documentNumber'),
    status: getValue('status'),
    remark: getValue('remark'),
    purpose: getValue('purpose'),
    vendorCode: getValue('vendorCode'),
    accountGroup: getValue('accountGroup'),
    companyCode: getValue('companyCode'),
    companyName: getValue('companyName'),
    vendorType: getValue('vendorType'),
    vendorName1: getValue('vendorName1'),
    vendorName2: getValue('vendorName2'),
    vendorName3: getValue('vendorName3'),
    vendorName4: getValue('vendorName4'),
    searchName: getValue('searchName'),
    industry: getValue('industry'),
    standardIndustry: getValue('standardIndustry'),
    taxId: getValue('taxId'),
    country: getValue('country'),
    province: getValue('province'),
    district: getValue('district'),
    subDistrict: getValue('subDistrict'),
    houseNumber: getValue('houseNumber'),
    buildingOrRoomNo: getValue('buildingOrRoomNo'),
    street: getValue('street'),
    postalCode: getValue('postalCode'),
    notRegisterRemark: getValue('notRegisterRemark'),
    vendorUsers: getValue('vendorUsers'),
    paymentTypeTransfer: getValue('paymentTypeTransfer'),
    paymentTypeCheque: getValue('paymentTypeCheque'),
    paymentTypeTtlc: getValue('paymentTypeTtlc'),
    vendorBanks: getValue('vendorBanks'),

    usePurchasingView: getValue('usePurchasingView'),
    purchasingOrg: getValue('purchasingOrg'),
    orderCurrency: getValue('orderCurrency'),
    paymentTerms: getValue('paymentTerms'),
    salePerson: getValue('salePerson'),
    salePersonTelephone: getValue('salePersonTelephone'),
    incoterm: getValue('incoterm'),
    incotermsLocation: getValue('incotermsLocation'),
    grBasedInvoiceVerification: getValue('grBasedInvoiceVerification'),

    attachment01: getValue('attachment01'),
    attachment02: getValue('attachment02'),
    attachment03: getValue('attachment03'),
    attachment04: getValue('attachment04'),
    attachment05: getValue('attachment05'),
    attachment06: getValue('attachment06'),
    attachment07: getValue('attachment07'),
    attachment08: getValue('attachment08'),
    attachment09: getValue('attachment09'),
    attachment10: getValue('attachment10'),
    attachment11: getValue('attachment11'),
    attachment12: getValue('attachment12'),
    attachment13: getValue('attachment13'),
    attachment14: getValue('attachment14'),
    attachment15: getValue('attachment15'),

    reconciliationAccount: getValue('reconciliationAccount'),
    sortKey: getValue('sortKey'),
    planningGroup: getValue('planningGroup'),
    accPaymentTerms: getValue('accPaymentTerms'),
    paymentMethod: getValue('paymentMethod'),
    paymentBlock: getValue('paymentBlock'),
    tradingPartner: getValue('tradingPartner'),
    previousAccount: getValue('previousAccount'),
    checkDoubleInvoice: getValue('checkDoubleInvoice'),
    payeeInDocument: getValue('payeeInDocument'),
    withholdingTaxs: getValue('withholdingTaxs'),
    branches: getValue('branches'),
    branchCode: getValue('branchCode'),
    branchDescription: getValue('branchDescription'),

    sn: getValue('sn'),
    actions: getValue('actions'),
    submittedDate: getValue('submittedDate'),
    modifiedDate: getValue('modifiedDate'),

    purchasingViewLoaded: getValue('purchasingViewLoaded'),
    accountingViewLoaded: getValue('accountingViewLoaded'),

    centralBlock: getValue('centralBlock'),
    allPurchasingBlock: getValue('allPurchasingBlock'),
    blockAllCompany: getValue('blockAllCompany'),
    blockCompanies: getValue('blockCompanies'),
    yearOfEstablishment: getValue('yearOfEstablishment'),
    bankLoan: getValue('bankLoan'),
    registeredCapital: getValue('registeredCapital'),
    paidUpRegisteredCapital: getValue('paidUpRegisteredCapital'),
    projectReference: getValue('projectReference'),
    income: getValue('income'),
    currentRatio: getValue('currentRatio'),
    profit: getValue('profit'),
    shareholder: getValue('shareholder'),
    vendorAuthorizedDirector: getValue('vendorAuthorizedDirector'),
    vendorSalePerson: getValue('vendorSalePerson')
  }

  const blockCompanies = getValue('blockCompanies') || []

  blockCompanies.forEach(c => {
    initialValues[`block_${c}`] = vf[`block_${c}`] !== undefined ? vf[`block_${c}`] : true
  })

  return ({
    valueForm: vf,
    formData: fd,
    workflow: state.vendorMaintenance.workflow,
    attachmentGroups: state.vendorMaintenance.attachmentGroups,
    initialValues
  })
}

const mapDispatchToProps = {
  getSupplierFormData,
  clearVMFormData,
  updateVM,
  appLoading,
  deleteVM,
  getWorkflow,
  showModal,
  checkTaxIdAvailable
}

const validate = (values) => {
  let errors = {}
  validations(values, 'title', [vCase.require], errors)
  // validations(values, 'requesterUser', [vCase.require], errors)
  validations(values, 'documentDate', [vCase.require], errors)
  validations(values, 'purpose', [vCase.require], errors)
  validations(values, 'accountGroup', [vCase.require], errors)

  if (values.purpose === 'create' || values.purpose === 'change') {
    validations(values, 'companyCode', [vCase.require], errors)
    validations(values, 'vendorType', [vCase.require], errors)
    validations(values, 'vendorName1', [vCase.require, vCase.maxLength40], errors)
    validations(values, 'vendorName2', [vCase.maxLength40], errors)
    validations(values, 'vendorName3', [vCase.maxLength40], errors)
    validations(values, 'vendorName4', [vCase.maxLength40], errors)
    validations(values, 'searchName', [vCase.require, vCase.maxLength20], errors)

    validations(values, 'industry', [vCase.require], errors)
    if (values.accountGroup === 'ZFOV') {
      validations(values, 'taxId', [vCase.maxLength13], errors)
    } else {
      validations(values, 'taxId', [vCase.require, vCase.maxLength13], errors)
    }
    validations(values, 'country', [vCase.require], errors)
    validations(values, 'province', [vCase.require], errors)
    validations(values, 'district', [vCase.require], errors)
    validations(values, 'subDistrict', [vCase.require], errors)
    validations(values, 'houseNumber', [vCase.require, vCase.maxLength10], errors)
    validations(values, 'buildingOrRoomNo', [vCase.require, vCase.maxLength60], errors)
    validations(values, 'street', [vCase.maxLength60], errors)
    validations(values, 'postalCode', [vCase.require, vCase.maxLength10], errors)

    if (['ZDOV', 'ZFOV', 'ZRPT', 'ZOTV'].includes(values.accountGroup)) {
      if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
        validations(values, 'notRegisterRemark', [vCase.require], errors)
      }
    }

    if (values.paymentTypeTransfer) {
      if ((values.vendorBanks || []).length === 0) {
        errors.paymentType = ' Minimum 1 row of bank account required!'
      }
    }

    if (values.usePurchasingView) {
      if (values.purpose === 'create' || values.purpose === 'change') {
        validations(values, 'purchasingOrg', [vCase.require], errors)
      }

      validations(values, 'orderCurrency', [vCase.require], errors)
      validations(values, 'paymentTerms', [vCase.require], errors)

      if (values.incoterm !== undefined && values.incoterm !== null && values.incoterm !== '') {
        validations(values, 'incotermsLocation', [vCase.require], errors)
      }
    }

    if (values.accountGroup === 'ZRPT' && values.purpose === 'create') {
      validations(values, 'reconciliationAccount', [vCase.require], errors)
      validations(values, 'sortKey', [vCase.require], errors)
      validations(values, 'planningGroup', [vCase.require], errors)
      validations(values, 'accPaymentTerms', [vCase.require], errors)
      validations(values, 'paymentMethod', [vCase.require], errors)
      validations(values, 'tradingPartner', [vCase.require], errors)
      validations(values, 'branchCode', [vCase.require], errors)
      validations(values, 'branchDescription', [vCase.require], errors)
    }

    if (values.accountGroup === 'ZRPT' && values.purpose === 'change' && values.accountingViewLoaded === true) {
      validations(values, 'reconciliationAccount', [vCase.require], errors)
      validations(values, 'sortKey', [vCase.require], errors)
      validations(values, 'planningGroup', [vCase.require], errors)
      validations(values, 'accPaymentTerms', [vCase.require], errors)
      validations(values, 'paymentMethod', [vCase.require], errors)
      validations(values, 'tradingPartner', [vCase.require], errors)
      validations(values, 'branchCode', [vCase.require], errors)
      validations(values, 'branchDescription', [vCase.require], errors)
    }
  }

  return errors
}

const VendorMaintenanceEditForm = reduxForm({
  form: 'formSupplierConvert',
  enableReinitialize: true,
  validate,
  onSubmitFail: scrollToFirstValidateFailElement
})(VendorMaintenanceEdit)

export default connect(mapStateToProps, mapDispatchToProps)(VendorMaintenanceEditForm)
